

























































import BtnDefault from '@/components/UI/BtnDefault.vue';
import {Component, Vue, Watch} from 'vue-property-decorator';
import DialogFooter from '@/components/UI/DialogFooter.vue';
import {namespace} from 'vuex-class';
import IPlatform from '@/components/icons/IPlatform.vue'

const dialog = namespace('dialog')
const forms = namespace('forms')

@Component({
  components: {
    BtnDefault,
    DialogFooter,
    'i-platform': IPlatform,
  },
  name: "ShardHistoryForm"
})
export default class ShardHistoryForm extends Vue {
  @dialog.Getter('fullDialogShow') protected fullDialogShow: any
  @dialog.Mutation('SetFullDialogShow') protected SetFullDialogShow: any
  @forms.Getter('options') protected options:any


  headers: any[] = [
    {text: this.$t('newShardList.historyForm.headers.date'), sortable: true, value: 'date'},
    {text: this.$t('newShardList.historyForm.headers.user'), sortable: true, value: 'user'},
    {text: this.$t('newShardList.historyForm.headers.action'), sortable: true, value: 'action'},
    {text: this.$t('newShardList.historyForm.headers.field'), sortable: true, value: 'field'},
    {text: this.$t('newShardList.historyForm.headers.platform'), sortable: true, value: 'platform'},
    {text: this.$t('newShardList.historyForm.headers.change'), sortable: false, value: 'change'}
  ]

  @Watch('fullDialogShow')
  getFullDialogShow(NewVal: any) {
  }

  timeConverter(UNIX_timestamp: any) {
    if(UNIX_timestamp == 0) return ''
    const a = new Date(UNIX_timestamp * 1000);
    const months = ['янв', 'фев', 'март', 'апр', 'май', 'июнь', 'июль', 'авг', 'сен', 'окт', 'ноя', 'дек'];
    const year = a.getFullYear();
    const month = this.dable(a.getMonth() + 1);
    const date = this.dable(a.getDate());
    const clock = this.dable(a.getHours())
    const min = this.dable(a.getMinutes())
    const rTime = clock + ':' + min
    const rDate = date + '.' + month + '.' + year;

    return {rDate, rTime};
  }

  dable(num: number) {
    return num < 10 ? '0' + num : num
  }

  save() {
    this.SetFullDialogShow(false)
  }

}
